import { createFileRoute } from "@tanstack/react-router";
import { PostEditor } from "@/components/blog/PostEditor";

export const Route = createFileRoute("/_admin/admin/blog/new")({
  component: () => <PostEditor mode="create" />,
});
